import { render, staticRenderFns } from "./Popup-parcel-divide.vue?vue&type=template&id=e24956a4&"
import script from "./Popup-parcel-divide.vue?vue&type=script&lang=ts&"
export * from "./Popup-parcel-divide.vue?vue&type=script&lang=ts&"
import style0 from "./Popup-parcel-divide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports